import { render, staticRenderFns } from "./AdminUmbClasseForm.vue?vue&type=template&id=6a288e08"
import script from "./AdminUmbClasseForm.vue?vue&type=script&lang=ts"
export * from "./AdminUmbClasseForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports